import type { GeneratedSummary } from '../types';

export default function parseGeneratedSummary(generatedSummary?: GeneratedSummary) {
  if (!generatedSummary?.summary) return null;

  if (generatedSummary.detail === 'BULLET_FORMAT_SUMMARY' || 'totalReviewsAtSummary' in generatedSummary) {
    return {
      ...generatedSummary,
      summary: (generatedSummary.summary as string).replaceAll('* ', '').split('\n'),
    };
  }
  return generatedSummary;
}
